import CellRangeDecorator from './slick.cellrangeselector';
export default CellRangeDecorator;
